import axios from "axios";

let $http = axios.create({
    withCredentials: true,
    crossdomain: true,
});

$http.interceptors.request.use(config => {
    config.headers['x-localization'] = document.documentElement.lang;
    return config;
});

export { $http }